import { styling } from '../core/styling.js';

const whiteSpace = styling({
    $whiteSpace: {
        type: 'string',
        properties: ['whiteSpace'],
    },
});

export { whiteSpace };
//# sourceMappingURL=whiteSpace.js.map
